export default __webpack_public_path__ + "static/media/pencil.53969266.svg";